import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobsOffer} from '../models/jobs-offer';
import 'rxjs/add/operator/map';
import {JobsOffersApplicant} from '../models/jobs-offers-applicant';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class JobOffersService {

  private jobUrl: string;
  private jobStatusUrl: string;
  private applicantUrl: string;

  constructor(private http: HttpAuth) {
    this.jobUrl = `${ environment.apiRoot }/job/`;
    this.jobStatusUrl = `${ environment.apiRoot }/job/`;
    this.applicantUrl = `${ environment.apiRoot }/applicant/`;

  }

  public _subject = new Subject<object>();
  public event = this._subject.asObservable();

  public publish (data: JobsOffer) {
    this._subject.next(data);
  }

  public getOffers(query?: string, venue?: string, status?: any[], page?: number, pagecount?: number,
    premium?: number, query_skill?: string, query_edu?: string, query_exp?: string, myOffer?: boolean): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (query) {
        params.set('query', query);
    }

    if (query_skill) {
        params.set('query_skill', query_skill);
    }
    if (query_edu) {
        params.set('query_edu', query_edu);
    }
    if (query_exp) {
        params.set('query', query_exp);
    }

    if (venue) {
        params.set('venue_id', venue);
    }
    // if (city) {
    //     params.set('city', city);
    // }
    if (status) {
        status.forEach(function(element, index, array) {
            params.append('status[]',  element);
        });
    }

    if (page) {
      params.append('page',  String(page));
    }

    if (pagecount) {
      params.append('pagecount',  String(pagecount));
    }

    if (premium !== undefined) {
      params.append('premium',  String(premium));
    }

    if (myOffer !== undefined) {
      if (myOffer) {
        params.append('myjobs',  String(1));
      } else {
        params.append('myjobs',  String(0));
      }
    }

    params.set('summary', '1');

    const options = new RequestOptions({search: params});

    return this.http.get(this.jobStatusUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersById(jobId: string): Observable<JobsOffer> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id',  jobId);
    const options = new RequestOptions({search: params});

    return this.http.get(this.jobUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postOffers(jobOffer: JobsOffer): Observable<JobsOffer[]> {
    const params: URLSearchParams = new URLSearchParams();
    const body = jobOffer;

    const options = new RequestOptions({search: params});

    return this.http.post(this.jobUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putOffersStatus(id, status): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {id: id, status: status};

    const options = new RequestOptions({search: params});

    return this.http.put(this.jobStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putOffersQuantity(id, quantity): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {id: id, quantity: quantity};

    const options = new RequestOptions({search: params});

    return this.http.put(this.jobStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersApplicantById(id, mandatoryrequirementsmet): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('id',  id);
    params.append('mandatoryrequirementsmet',  mandatoryrequirementsmet);

    const options = new RequestOptions({search: params});

    return this.http.get(this.applicantUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersApplicantByOffer(id, status = 300): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('id',  id);
    params.append('status',  String(status));
    params.append('summary',  '1');
    params.append('pagecount',  '100');
    params.append('mandatoryrequirementsmet',  '1');


    const options = new RequestOptions({search: params});

    return this.http.get(this.applicantUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersApplicantByOfferDossier(id, status = 300): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('id',  id);
    params.append('status',  String(status));
    params.append('summary',  '1');
    params.append('pagecount',  '100');


    const options = new RequestOptions({search: params});

    return this.http.get(this.applicantUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    const body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/job-offers.service.ts